import type { FC } from "react";
import { WarningDialog } from "../../../../utils/warningDialogs/WarningDialog";
import type { useGapsAddStaff } from "./useGapsAddStaff";

type Props = {
	/** The add's own warning gates (`useGapsAddStaff`'s `warnings`). */
	warnings: ReturnType<typeof useGapsAddStaff>["warnings"];
	/** Backs out of the add from any gate — nothing is written. */
	onCancel: () => void;
};

/**
 * The gates an add passes before it writes — PTO, the unit's target, agency staff, overtime, daily hours, employment
 * status — as the desktop's add dialog raises them (`WarningDialog`). Each confirm goes on to the next gate or the write.
 */
export const GapsAddWarningDialog: FC<Props> = ({ warnings, onCancel }) => (
	<WarningDialog
		openPtoWarning={warnings.warningState.isPtoWarningOpen}
		openTargetWarning={warnings.warningState.isTargetWarningOpen}
		openAgencyWarning={warnings.warningState.isAgencyWarningOpen}
		openOvertimeWarning={warnings.warningState.isOvertimeWarningOpen}
		openDailyHoursWarning={warnings.warningState.isDailyHoursWarningOpen}
		openEmployeeStatusWarning={warnings.warningState.isEmployeeStatusWarningOpen}
		overtimeDetails={warnings.warningState.overtimeDetails}
		dailyHoursDetails={warnings.warningState.dailyHoursDetails}
		targetDetails={warnings.warningState.targetDetails}
		employeeStatusDetails={warnings.warningState.employeeStatusDetails}
		longShiftDuration={warnings.longShiftDuration}
		onCancelPto={onCancel}
		onConfirmPto={warnings.handlePtoConfirm}
		onCancelTarget={onCancel}
		onConfirmTarget={warnings.handleTargetConfirm}
		onCancelAgency={onCancel}
		onConfirmAgency={warnings.handleAgencyConfirm}
		onCancelOvertime={onCancel}
		onConfirmOvertime={warnings.handleOvertimeConfirm}
		onCancelDailyHours={onCancel}
		onConfirmDailyHours={warnings.handleDailyHoursConfirm}
		onCancelEmployeeStatus={onCancel}
		onConfirmEmployeeStatus={warnings.handleEmployeeStatusConfirm}
	/>
);
